

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD-MMM-YYYY hh:mm:ss';
export const DATE_TIME_24H_FORMAT = 'DD-MMM-YYYY HH:mm:ss';
export const IE_DATE_TIME_24H_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const KENDO_DATE_FORMAT = 'dd-MMM-yyyy';
export const TEMPLATE_KENDO_DATE_FORMAT = '{0:dd-MMM-yyyy}';
export const KENDO_DATE_TIME_FORMAT = 'dd-MMM-yyyy HH:mm';
export const BACK_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const CURRENCY_FORMAT = '.2-2';
export const CURRENCY_SYMBOL = '€';
